// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-scrollable[data-v-4c55bde4] {\n  overflow-y: auto;\n  height: 400px;\n}\n.itemtype-width[data-v-4c55bde4] {\n  width: 140px;\n}\n.total-width[data-v-4c55bde4] {\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
